import { VRNFEST_CONTEST_TERMS_PAGE_PATH } from '@/features/vrnfest/constants';

export default function VrnfestFooter() {
  return (
    <footer className="-mt-[44px] w-full border-t border-[#F4F4F41A] bg-[#1B1D22]">
      <div className="mx-auto flex w-full max-w-[1360px] flex-row items-center justify-between gap-3 px-4 py-8 lg:px-[120px]">
        <a
          href={VRNFEST_CONTEST_TERMS_PAGE_PATH}
          target="_blank"
          rel="noopener noreferrer"
          className="shrink-0 font-sans text-[10px] font-normal leading-[100%] tracking-[0.03em] text-[#888C92] transition-colors hover:text-white min-[896px]:text-[11px]"
        >
          Условия конкурса
        </a>
        <p className="roboto-flex-compressed shrink-0 text-right text-[18px] font-extra-black uppercase leading-[90%] tracking-normal text-[#F4F4F4] [leading-trim:cap] min-[896px]:text-[24px]">
          MOLWE × VRNFEST
        </p>
      </div>
    </footer>
  );
}
